import React from 'react'
import { Headings, PaddedImage, GenerateLink, PlayBtn } from 'scripts/helpers/AppHelper'
import { ShowAssocWith, ShowDate } from './helpers/ListHelpers'
import { decodeHTML, extractSubType, getTrackingTag } from 'scripts/lib/utils'
import { actions } from 'scripts/store'

const ListItem = (props) => {
  const { item: {id, slug, images, createdAt: date, associatedWith, title},
    sizeRight, sizeLeft, showdate, showassoc, truncate, section } = props
  const category = extractSubType(associatedWith, 'category')
  const imageURL = images && images.header ? images.header.url : null
  const titleText = title ? title.text : null
  const trackingTag = getTrackingTag(associatedWith)
  const customOnClick = () => {
    actions.setSection(section)
    actions.setArticleTag(trackingTag)
  }

  // common link props
  const commonLinkProps = {type: 'post', id: id, slug: slug, title: titleText, customOnClick}

  // title link
  const titleLinkProps = Object.assign({...commonLinkProps}, {element: titleText, truncate: truncate})
  const titleElement = <GenerateLink {...titleLinkProps} />

  // image link
  const imageProps = {
    image: imageURL,
    containerClass: 'thumbnail image-wrapper',
    altText: decodeHTML(titleText)
  }
  const image = <PaddedImage {...imageProps}/>
  const imageLinkProps = Object.assign({...commonLinkProps}, {element: image})
  const imageElement = <GenerateLink {...imageLinkProps} />

  // showdate props
  const showDateProps = {showdate, date}
  // show assoc
  const showAssocProps = {showassoc, data: category, customOnClick}

  // Headings
  const headingsProps = {
    heading: 4,
    cssClass: 'media-heading list-media-heading',
    content: titleElement
  }

  return (
    <div className="row list-item">
      <div className={`col small-5 med-${sizeLeft}`}>
        <div className="thumbnail-wrapper">
          {imageElement}
          <PlayBtn {...props.item} />
        </div>
      </div>
      <div className={`col small-7 med-${sizeRight}`}>
        <div className="meta-container">
          <ShowAssocWith {...showAssocProps} />
          <ShowDate {...showDateProps} />
        </div>
        <Headings {...headingsProps} />
      </div>
    </div>
  )
}

export default ListItem



// WEBPACK FOOTER //
// ./assets/js/components/list/ListItem.jsx